/* Reine Hilfen fürs Diktieren (getestet in diktatFeld.test.js): welches Feld ist ein Ziel, welche Art ist es, was kommt wohin. */

/* ── Zielfeld ─────────────────────────────────────────────────────────────────────────────────────────────────────────────────── */
const TEXT_TYPEN = ['text', 'search'];
export function zielFeld(el) {
  if (!el || el.nodeType !== 1) return null;
  if (el.closest?.('[data-diktat="aus"]')) return null;
  if (el.tagName === 'TEXTAREA') return el.disabled || el.readOnly ? null : el;
  if (el.tagName === 'INPUT') {
    const typ = (el.getAttribute('type') || 'text').toLowerCase();
    return TEXT_TYPEN.includes(typ) && !el.disabled && !el.readOnly ? el : null;
  }
  if (el.isContentEditable) return el;
  return null;
}
/* Art des Feldes für die Formatierung auf dem Server (Schlusspunkt, Großschreibung). */
export function feldArt(el) {
  const gesetzt = el.getAttribute?.('data-diktat-feld');
  if (gesetzt) return gesetzt;
  const hinweis = `${el.name || ''} ${el.id || ''} ${el.getAttribute?.('placeholder') || ''} ${el.getAttribute?.('aria-label') || ''}`.toLowerCase();
  if (el.type === 'search' || /such|search|filter/.test(hinweis)) return 'suche';
  if (/nachricht|chat|message|antwort|schreib/.test(hinweis)) return 'chat';
  if (el.tagName === 'INPUT') return 'kurz';
  return 'notiz';
}

/* ── Einfügen an der Cursor-Position ──────────────────────────────────────────────────────────────────────────────────────────── */

/* Reine Funktion (getestet): was an welche Stelle kommt – mit Leerzeichen davor/danach, wo nötig. */
export function einfuegePlan(wert, start, ende, text) {
  const s = start == null ? wert.length : start;
  const e = ende == null ? wert.length : ende;
  const davor = wert.slice(0, s);
  const danach = wert.slice(e);
  let t = (text || '').trim();
  if (!t) return null;
  if (danach.split('\n')[0].trim() && /\.$/.test(t) && !/\n/.test(t)) t = t.slice(0, -1);       // mitten im Satz kein Schlusspunkt
  const vorn = davor && !/[\s\n(„"'[]$/.test(davor) && !/^[.,;:!?)]/.test(t) ? ' ' : '';
  const hinten = danach && !/^[\s\n.,;:!?)]/.test(danach) ? ' ' : '';
  const eingefuegt = vorn + t + hinten;
  return { wert: davor + eingefuegt + danach, cursor: davor.length + vorn.length + t.length + hinten.length };
}
